<div class="flex items-center justify-center" [className]="customClasses">
    <img class="w-auto h-full" src="assets/images/logo/LOGO_MERCADAO_VERMELHO-1.svg" />
</div>
